import { apiBaseUrl } from 'api/utils/detectHost';
import axios from 'axios';
import { updateHeaders } from 'utils/axios';

export default async function getCsrfToken() {
  const response = await axios.post<{ csrfToken: string }>(`${apiBaseUrl()}/csrf`);
  const csrfToken = response?.data?.csrfToken;

  updateHeaders({ csrfToken }); // add current CSRF token to headers

  return csrfToken;
}
